import React from 'react';
import { useTranslation } from 'react-i18next';
import { Partner } from 'src/services/partner';

interface ReadOnlyPartnerInfoProps {
  partner?: Partner | null;
  className?: string;
}

const ReadOnlyPartnerInfo: React.FC<ReadOnlyPartnerInfoProps> = ({ partner, className }) => {
  const { t } = useTranslation();

  if (!partner) return null;

  return (
    <div className={`grid grid-cols-2 gap-24 w-full ${className || ''}`}>
      <div className="flex flex-col gap-6">
        <span className="typo-text-14 text-faded">{partner.company_name || partner.name || '—'}</span>

        {partner.address && (
          <div className="flex flex-col gap-2 text-faded">
            {partner.address.street && <span className="typo-text-14">{partner.address.street}</span>}
            {partner.address.city && <span className="typo-text-14">{partner.address.city}</span>}
            {partner.address.zip_code && <span className="typo-text-14">{partner.address.zip_code}</span>}
            {partner.address.country_name && <span className="typo-text-14">{partner.address.country_name}</span>}
          </div>
        )}
      </div>

      <div className="flex flex-col gap-6">
        {partner.email && (
          <div className="flex flex-col gap-2">
            <span className="typo-text-14--bold">{t('general.email')}</span>
            <span className="typo-text-14 text-faded">{partner.email}</span>
          </div>
        )}

        {partner.phone && (
          <div className="flex flex-col gap-2">
            <span className="typo-text-14--bold">{t('general.phone')}</span>
            <span className="typo-text-14 text-faded">{partner.phone}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReadOnlyPartnerInfo;
